import { BLUE } from '../../styles/colors';
import styled from 'styled-components';

export const Container = styled.div`
    width: 48px;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 100%;
    background-color: ${BLUE};
    cursor: pointer;
`
